import { MainFormModalModule } from './../components/main-form-modal/main-form-modal.mdl';
import { BrowserModule } from '@angular/platform-browser';

import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@NgModule({
	imports: [
		CommonModule,
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		MatInputModule,
		MatIconModule,
		MatFormFieldModule,
		MatButtonModule,
MainFormModalModule
	],
	declarations: [
		LoginComponent,
	],
	exports: [
		LoginComponent
	],
	providers: []
})
export class LoginMdl { }

